// Sellers.jsx
import React, { useEffect, useState } from "react";
import Navbar from "../Components/NavBar";
import "../css/LandingPage.css";
import "../css/NavBar.css";
import "../css/GuidePages.css";
import sellersGuidePdf from "../documents/Sellers_Guide.pdf";

const COVER_IMG = "/imgs/guides/sellers-cover.jpg";

export default function Sellers() {
  useEffect(() => {
    const hash = window.location.hash?.replace("#", "");
    if (!hash) return;
    requestAnimationFrame(() => {
      const el = document.getElementById(hash);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }, []);

  const [guideOpen, setGuideOpen] = useState(false);
  const isMobile = window.matchMedia("(max-width: 768px)").matches;

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && setGuideOpen(false);
    if (guideOpen) window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [guideOpen]);

  const handlePrintGuide = () => {
    const w = window.open(sellersGuidePdf, "_blank", "noopener,noreferrer");
    setTimeout(() => {
      try { w?.focus(); w?.print(); } catch {}
    }, 600);
  };

  const determiningFactors = [
    { title: "The Price", text: "We’ll price correctly the first time using a local market analysis." },
    { title: "Condition", text: "De-clutter, clean, and elevate curb appeal to improve offers." },
    { title: "Marketing", text: "Exposure + online tools + reputation + connections to get sold with less stress." },
  ];

  const sellingSteps = [
    "Before Listing",
    "Preparing to List",
    "Pricing Your Home",
    "Lasting Image (Photography)",
    "Our Marketing Plan",
    "Home Showings",
    "Hosting Open Houses",
    "Inspection & Appraisal",
    "Contract / Offer Negotiations",
    "Closing Day + Final Steps",
  ];

  return (
    <div className="guide-page">
      <Navbar variant="sellers" />

      {/* PDF-like cover hero */}
      <section className="guide-hero" id="overview">
        <div className="guide-hero-media">
          <img src={COVER_IMG} alt="Sellers guide cover" />
        </div>

        <div className="guide-hero-panel">
          <p className="guide-hero-kicker">Kentucky Home Living</p>
          <h1 className="guide-hero-title">Seller’s Guide</h1>
          <p className="guide-hero-subtitle">
            A guide to help you with your Kentucky home selling process.
          </p>

          <div className="guide-hero-actions">
            <button className="btn accent" onClick={() => setGuideOpen(true)}>View Guide</button>
            <a className="btn-secondary-guides" href="/contact">Talk to Brooke</a>
          </div>
        </div>
      </section>

      <main className="interior-inner">
        {/* Determining Factors */}
        <section className="guide-section" id="factors">
          <div className="guide-section-header">
            <p className="guide-section-eyebrow">Determining Factors</p>
            <h2 className="guide-section-title">Before listing your home</h2>
            <p className="guide-section-lede">
              Three key areas that influence interest, offers, and speed-to-sell.
            </p>
          </div>

          <div className="guide-grid">
            {determiningFactors.map((f, idx) => (
              <div className="guide-card" key={f.title}>
                <div className="row">
                  <div className="badge-num">{idx + 1}</div>
                  <div>
                    <h4 style={{ margin: 0 }}>{f.title}</h4>
                    <p style={{ marginTop: 6 }}>{f.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* 10 Steps */}
        <section className="guide-section" id="steps">
          <div className="guide-section-header">
            <p className="guide-section-eyebrow">Steps</p>
            <h2 className="guide-section-title">10 steps to selling a home</h2>
          </div>

          <div className="guide-grid">
            {sellingSteps.map((label, idx) => (
              <div className="guide-card" key={label}>
                <div className="row">
                  <div className="badge-num">{idx + 1}</div>
                  <div>
                    <h4 style={{ margin: 0 }}>{label}</h4>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        <div className="guide-callout" style={{ margin: "0 0 3rem" }}>
          <strong>Ready to list?</strong> Let’s talk timeline, prep, and pricing.
          <div style={{ marginTop: 12 }}>
            <a className="btn primary" href="/contact">Let’s Talk</a>{" "}
            <a className="btn secondary" href="/reviews">See Reviews</a>
          </div>
        </div>
      </main>

      {/* modal stays same */}
      {guideOpen && (
        <div
          className="guide-modal-overlay"
          role="dialog"
          aria-modal="true"
          aria-label="Seller Guide"
          onClick={() => setGuideOpen(false)}
        >
          <div className="guide-modal" onClick={(e) => e.stopPropagation()}>
            <div className="guide-modal-header">
              <div>
                <div className="guide-modal-title">Seller Guide</div>
                <div className="guide-modal-subtitle">
                  {isMobile ? "Open guide in a new tab." : "Browse here, or print from a new tab."}
                </div>
              </div>

              {!isMobile && (
                <div className="guide-modal-actions">
                  <button className="btn accent small" onClick={handlePrintGuide}>Print</button>
                  <button className="btn secondary small" onClick={() => setGuideOpen(false)}>Close</button>
                </div>
              )}
            </div>

            <div className="guide-modal-body">
              {isMobile ? (
                <div className="guide-modal-mobile">
                  <a className="btn accent" href={sellersGuidePdf} target="_blank" rel="noreferrer">
                    Open Guide
                  </a>
                  <button className="btn secondary" onClick={() => setGuideOpen(false)}>Close</button>
                </div>
              ) : (
                <iframe title="Seller Guide PDF" src={sellersGuidePdf} className="guide-modal-frame" />
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
